import ModusServiceModel from "../ModusServiceModel";
import Document from "../document/DocumentModel";

export default class ResultDocumentModel extends ModusServiceModel {
  modelName() {
    return 'result-documents';
  }
  icon() {
    return this.type === "pdf"
      ? 'file-pdf'
      : 'link';
  }
  defaults() {
    return {
      id: null,
      result_id: null,
      result: null,
      type: null,
      document_id: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_id: (val) => (this.nullStringMutator(val)),
      type: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      document_id: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
  getDocument() {
    const document = new Document({ id: this.document_id });
    
    return new Promise(resolve => {
      return document.fetch().then(() => {
        return resolve(document);
      });
    });
  }

}
